/// <reference path="../../../exported/ajaxUtils.d.ts" />

import React = require("react");
import {RestDataLoader} from "../../dashboard/widgets/unilever/RestDataLoader";
import FeedbackModalController from "../../feedback/FeedbackModalController";
import {FeedbackModal} from "../../feedback/ui/FeedbackModal";
import {Loader} from "../../components/Utils/loader/Loader";
import {PredictiveMaintenanceNotFoundNode} from "./PredictiveMaintenanceNotFoundNode";
import {PredictiveMaintenanceQuestionNode} from "./PredictiveMaintenanceQuestionNode";
import {PredictiveMaintenanceTerminalDummyNode} from "./PredictiveMaintenanceTerminalDummyNode";
import {PredictiveMaintenanceTerminalNode} from "./PredictiveMaintenanceTerminalNode";

import "./PredictiveMaintenanceQuestionaire.scss";

const UNKNOWN = "UNKNOWN";

const WORK_ORDER_ID_URL = "workorderId";
const PREDICTIVE_MAINTENANCE_INFO_URL = "predictiveMaintenanceInfo";
const ALARM_GUID_URL = "getAlarmGuid";
const OPEN_WORK_ORDER_URL = "wizardAddAlarmToWorkOrder";

interface PredictiveMaintenanceInfo {
    helpTitle: string;
    question: string;
    telephoneNumber: string;
    equipmentInsideTranslation: string;
    locationDescriptions: string;
    locationProvince: string;
    locationCountry: string;
}

interface PredictiveMaintenanceQuestionnaireProps {
    deviceGuid: string;
    stackManager: any;
    componentId: number;
    alarmId: number;
    alarmData: any;
    alarmPanel: any;
}

interface PredictiveMaintenanceQuestionnaireState {
    deviceQuestions: JSONDeviceQuestions;
    deviceQuestionsRequestGuid: string;
    questionCode: string;
    questionToShow: QuestionJSON;
    predictiveConfiguration: PredictiveMaintenanceInfo;
    showCreateWorkOrderNode: boolean;
}

interface QuestionJSON {
    code: string;
    description: string;
    priority: number;
    status: string;
    suggestion: string;
}

interface Fault {
    accepted: boolean;
    title: string;
    type: string;
    workOrder: string;
    code: string; // SE "dummy" allora predictive non ha trovato soluzioni
}

interface JSONDeviceQuestions {
    deviceGuid: string;
    fault: Fault;
    guid: string;
    questions: QuestionJSON[];
    accepted: boolean;
}

interface PatchRequest {
    op: string;
    path: string;
    value: any;
}

interface ServerRequestWorkOrderIdRequest {
    workOrderGuid: string;
}

interface QuestionAnswer {
    questionCode: string;
    answer: string;
}

export class PredictiveMaintenanceQuestionnaire
    extends React.Component<PredictiveMaintenanceQuestionnaireProps, PredictiveMaintenanceQuestionnaireState> {

    private questionAnswers: QuestionAnswer[] = [];

    private readonly feedbackModalController: FeedbackModalController;

    constructor(props: PredictiveMaintenanceQuestionnaireProps) {
        super(props);
        this.state = {
            deviceQuestions: null,
            deviceQuestionsRequestGuid: null,
            questionCode: null,
            questionToShow: null,
            predictiveConfiguration: null,
            showCreateWorkOrderNode: false,
        };
        this.editStatus = this.editStatus.bind(this);
        this.resetLastAnswer = this.resetLastAnswer.bind(this);
        this.openWorkOrder = this.openWorkOrder.bind(this);
        this.resetAllAnswers = this.resetAllAnswers.bind(this);
        this.openWorkOrderDirect = this.openWorkOrderDirect.bind(this);
        this.retrieveQuestions = this.retrieveQuestions.bind(this);
        this.questionAnswers = [];

        this.feedbackModalController = new FeedbackModalController();
    }

    public findQuestionToShow(questions: QuestionJSON[]): QuestionJSON {
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < questions.length; i++) {
            if (questions[i].status === UNKNOWN) {
                return questions[i];
            }
        }
        return null;
    }

    public componentDidMount(): void {
        this.retrievePredictiveConfiguration();
    }

    public render() {
        if (this.state.predictiveConfiguration == null
            || (this.state.deviceQuestions == null && !this.state.showCreateWorkOrderNode)
        ) {
            return (
                <div id="alarmPanelQuestionnaire" className="alarmPanelQuestionnaire" style={{width: "450px"}}>
                    <div id="alarmPanelQuestionnaireSlider" className="alarm-panel-questionnaire-slider">
                        <div className="alarmPanelQuestion alarmPanelTerminalQuestionTitleContent">
                            <Loader/>
                        </div>
                    </div>
                </div>
            );
        }
        return (
            <div id="alarmPanelQuestionnaire" className="alarmPanelQuestionnaire" style={{width: "450px"}}>
                <div id="alarmPanelQuestionnaireSlider" className="alarm-panel-questionnaire-slider">
                    {this.showQuestionNodeOrTerminalNode()}
                    <FeedbackModal/>
                </div>
            </div>
        );
    }

    private showQuestionNodeOrTerminalNode() {
        if (this.state.showCreateWorkOrderNode) {
            return (
                <PredictiveMaintenanceNotFoundNode
                    alarmId={this.props.alarmId}
                    openWorkOrder={this.openWorkOrderDirect}
                    alarmData={this.props.alarmData}
                    alarmPanel={this.props.alarmPanel}
                />
            );
        }
        if (this.state.deviceQuestions.fault == null) {
            const canGoBack = this.findAnswerPosition(this.state.questionToShow.code) > 0;
            return (
                <PredictiveMaintenanceQuestionNode
                    questionToShow={this.state.questionToShow}
                    editStatus={this.editStatus}
                    resetLastAnswer={this.resetLastAnswer}
                    questionTranslation={this.state.predictiveConfiguration.question}
                    status={this.findQuestionStatus(this.state.questionToShow)}
                    canGoBack={canGoBack}
                    suggestion={this.state.questionToShow.suggestion}
                />
            );
        }
        if (this.state.deviceQuestions.fault.code === "dummy") {
            return (
                <PredictiveMaintenanceTerminalDummyNode
                    fault={this.state.deviceQuestions.fault.title}
                    openWorkOrder={this.openWorkOrder}
                    resetAllAnswers={this.resetAllAnswers}
                    alarmData={this.props.alarmData}
                    alarmPanel={this.props.alarmPanel}
                />
            );
        }
        return (
            <PredictiveMaintenanceTerminalNode
                fault={this.state.deviceQuestions.fault.title}
                openWorkOrder={this.openWorkOrder}
                alarmData={this.props.alarmData}
                alarmPanel={this.props.alarmPanel}
            />
        );
    }

    private findAnswerPosition(code: string) {
        for (let i = 0; i < this.state.deviceQuestions.questions.length; i++) {
            if (this.state.deviceQuestions.questions[i].code === code) {
                return i;
            }
        }
        return 0;
    }

    private editStatus(newStatus: string) {

        (window as any).alarmsQuestionnaireStatus = (window as any).alarmsQuestionnaireStatus || {};
        (window as any).alarmsQuestionnaireStatus[this.props.alarmId] = true;

        const q: QuestionJSON = this.state.questionToShow;
        q.status = newStatus;
        const question: QuestionAnswer = this.findQuestionAnswered(this.state.questionToShow.code);
        if (question !== null && question.answer === newStatus) {
            const nextQuestion: QuestionJSON = this.findNextQuestionAnswer(this.state.questionToShow.code);
            this.setState({questionToShow: nextQuestion, questionCode: nextQuestion.code});
            return;
        }
        let requests: PatchRequest[] = [];
        if (question !== null && question.answer !== newStatus) {
            requests = this.resetNextAnswer(this.state.questionToShow.code);
            this.resetQuestionAlreadyAnswered(this.state.questionToShow.code);
        }
        this.addQuestionAlreadyAnswered(q);
        const requestBody: PatchRequest = {
            op: "replace",
            path: "/questions/" + this.state.questionToShow.code + "/status",
            value: newStatus,
        };
        requests.push(requestBody);
        this.patchQuestion(requests);
    }

    private resetNextAnswer(code: string) {
        const answers: PatchRequest[] = [];
        let find: boolean = false;
        for (let i = 0; i < this.questionAnswers.length; i++) {
            if (find && this.state.deviceQuestions.questions[i].code !== UNKNOWN) {
                const answerPatch: PatchRequest = {
                    op: "replace",
                    path: "/questions/" + this.state.deviceQuestions.questions[i].code + "/status",
                    value: UNKNOWN,
                };
                answers.push(answerPatch);
            }
            if (!find && code === this.state.deviceQuestions.questions[i].code) {
                find = true;
            }
        }
        return answers;
    }

    private findQuestionAnswered(code: string) {
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < this.questionAnswers.length; i++) {
            if (this.questionAnswers[i].questionCode === code) {
                return this.questionAnswers[i];
            }
        }
        return null;
    }

    private findNextQuestionAnswer(code: string) {
        let find: boolean = false;
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < this.state.deviceQuestions.questions.length; i++) {
            if (find) {
                return this.state.deviceQuestions.questions[i];
            }
            if (this.state.deviceQuestions.questions[i].code === code) {
                find = true;
            }
        }
        return null;
    }

    private previusQuestionAnswer(code: string) {
        let find: boolean = false;
        // tslint:disable-next-line:prefer-for-of
        for (let i = this.state.deviceQuestions.questions.length - 1; i >= 0; i--) {
            if (find) {
                return this.state.deviceQuestions.questions[i];
            }
            if (this.state.deviceQuestions.questions[i].code === code) {
                find = true;
            }
        }
        return null;
    }

    private resetLastAnswer() {
        /*
        let position = this.findAlreadyAnswQuestionPos(this.state.questionToShow.code);
        if (position === -1 && this.questionAnswers.length > 0) {
            position = this.questionAnswers.length - 1;
        } else if (position > 0) {
            position = position - 1;
        } else {
            return;
        }

        const requestBody: PatchRequest = {
            op: "replace",
            path: "/questions/"
                + this.questionAnswers[position].questionCode
                + "/status",
            value: UNKNOWN,
        };
        this.patchQuestion([requestBody]);
        */
        const nextQuestion: QuestionJSON = this.previusQuestionAnswer(this.state.questionToShow.code);
        this.setState({questionToShow: nextQuestion, questionCode: nextQuestion.code});
    }

    private findAlreadyAnswQuestionPos(code: string): number {
        const answeredQuestionCodes: string [] = this.questionAnswers.map(
            (el) => {
                return el.questionCode;
            },
        );
        return answeredQuestionCodes.indexOf(code);
    }

    private resetAllAnswers() {
        this.questionAnswers = [];
        // tslint:disable-next-line:prefer-const
        let questions: PatchRequest[] = [];
        this.state.deviceQuestions.questions.forEach((question: QuestionJSON) => {
            const requestBody: PatchRequest = {
                op: "replace",
                path: "/questions/"
                    + question.code
                    + "/status",
                value: UNKNOWN,
            };
            questions.push(requestBody);
        });
        this.patchQuestion(questions);
    }

    private openWorkOrder() {
        Ajax.vbxAjax({
            url: ALARM_GUID_URL,
            data: {alarmId: this.props.alarmId},
            type: "POST",
            cache: false,
            success: (response: string) => {
                if (response != null) {
                    const patchList: PatchRequest[] = this.orderAnswer();
                    const requestBody1: PatchRequest = {
                        op: "add",
                        path: "/accepted",
                        value: true,
                    };
                    const requestBody2: PatchRequest = {
                        op: "add",
                        path: "/alarmGuid ",
                        value: response,
                    };
                    patchList.push(requestBody1);
                    patchList.push(requestBody2);
                    this.patchQuestion(patchList);
                    if ((window as any).alarmsQuestionnaireStatus) {
                        (window as any).alarmsQuestionnaireStatus[this.props.alarmId] = undefined;
                    }
                }
            },
            error: () => {
                if ((window as any).alarmsQuestionnaireStatus) {
                    (window as any).alarmsQuestionnaireStatus[this.props.alarmId] = undefined;
                }
            },
        });
    }

    private patchQuestion(parameter: PatchRequest[]) {
        const questionGuid: string = this.state.deviceQuestions.guid;
        this.setState({deviceQuestions: null, showCreateWorkOrderNode: false});
        RestDataLoader.patchJSON(
            "devices/" + this.props.deviceGuid + "/solutions/" + questionGuid,
            {list: parameter},
            (questions: JSONDeviceQuestions) => {
                questions.questions = this.orderQuestions(questions.questions);
                const nextQuestion: QuestionJSON = this.findQuestionToShow(questions.questions);
                this.setState({
                    deviceQuestions: questions,
                    questionToShow: nextQuestion,
                    questionCode: nextQuestion != null ? nextQuestion.code : null,
                });
                if (questions.fault != null && questions.fault.workOrder != null) {
                    this.findWorkOrderIdByGuid();
                }
            },
            () => {
                this.retrieveQuestions();
            },
        );
    }

    private findWorkOrderIdByGuid() {
        const params: ServerRequestWorkOrderIdRequest = {workOrderGuid: this.state.deviceQuestions.fault.workOrder};
        Ajax.vbxAjax({
            url: WORK_ORDER_ID_URL,
            data: params,
            type: "POST",
            cache: false,
            success: (response: number) => {
                if (response != null) {
                    this.redirectToWorkOrder(response);
                }
            },
        });
    }

    private openWorkOrderDirect() {
        // da aggiungere lo sfarfallio
        const params: any = {alarmid: this.props.alarmId};
        Ajax.vbxAjax({
            url: OPEN_WORK_ORDER_URL,
            data: params,
            type: "POST",
            cache: false,
            success: (response: any) => {
                if (response != null && response.workOrderId != null) {
                    this.redirectToWorkOrder(response.workOrderId);
                }
            },
        });
    }

    private redirectToWorkOrder(workOrderId: number) {
        this.props.stackManager.addNewLevel("WorkOrderDetailLevel", {id: workOrderId});
    }

    private retrievePredictiveConfiguration() {
        Ajax.vbxAjax({
            url: PREDICTIVE_MAINTENANCE_INFO_URL,
            data: {componentId: this.props.componentId},
            type: "POST",
            cache: false,
            success: (response: PredictiveMaintenanceInfo) => {
                if (response != null) {
                    this.setState({predictiveConfiguration: response});
                    this.retrieveQuestions();
                }
            },
        });
    }

    private retrieveQuestions() {
        RestDataLoader.postJSON(
            "devices/" + this.props.deviceGuid + "/solutions",
            {},
            (questions: JSONDeviceQuestions) => {
                const q: QuestionJSON = this.findQuestionToShow(questions.questions);
                this.setState({
                    deviceQuestions: questions,
                    deviceQuestionsRequestGuid: questions.guid,
                    showCreateWorkOrderNode: false,
                    questionToShow: q,
                });
            },
            () => {
                this.setState({showCreateWorkOrderNode: true});
            },
        );
    }

    private orderQuestions(questions: QuestionJSON[]) {
        if (this.questionAnswers.length === 0) {
            return questions;
        }
        const answeredQuestionCodes = this.questionAnswers.map(
            (el) => {
                return el.questionCode;
            },
        );
        const alreadyAnsweredQuestions = [];
        const notAnsweredQuestion = [];
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < questions.length; i++) {
            if (answeredQuestionCodes.indexOf(questions[i].code) >= 0) {
                alreadyAnsweredQuestions.push(questions[i]);
            } else {
                notAnsweredQuestion.push(questions[i]);
            }
        }
        return alreadyAnsweredQuestions.concat(notAnsweredQuestion);
    }

    private resetQuestionAlreadyAnswered(code: string) {
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < this.questionAnswers.length; i++) {
            if (this.questionAnswers[i].questionCode === code) {
                this.questionAnswers = this.questionAnswers.slice(0, i + 1);
                return;
            }
        }
    }

    private addQuestionAlreadyAnswered(question: QuestionJSON) {
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < this.questionAnswers.length; i++) {
            if (this.questionAnswers[i].questionCode === question.code) {
                this.questionAnswers[i].answer = question.status;
                // this.questionAnswers = this.questionAnswers.slice(0, i + 1);
                return;
            }
        }
        this.questionAnswers.push({questionCode: question.code, answer: question.status});
    }

    private findQuestionStatus(question: QuestionJSON) {
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < this.state.deviceQuestions.questions.length; i++) {
            if (this.state.deviceQuestions.questions[i].code === question.code) {
                return this.state.deviceQuestions.questions[i].status;
            }
        }
        return UNKNOWN;
    }

    private orderAnswer() {
        const answers: PatchRequest[] = [];
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < this.questionAnswers.length; i++) {
            const answerPatch: PatchRequest = {
                op: "add",
                path: "/orderedAnswers/-",
                value: this.questionAnswers[i].questionCode,
            };
            answers.push(answerPatch);
        }
        return answers;
    }
}
